import { IConversations } from '../components/Conversations/Conversations'
import { MessageType } from '../types/conversations'
import { buildParams } from '../utils/useQueryParams'

import axiosAuth from './axiosAuth'

export const getConversations = (
    controller: AbortController,
    pagination: number,
    filters: Record<
        string,
        (string | null)[] | null | undefined | string | number
    >
) => {
    const params = filters && `&${new URLSearchParams(buildParams(filters))}`

    return axiosAuth.get<IConversations[]>(
        `/conversations?perPage=10&pageNum=${pagination}${
            params ? params : ''
        }`,
        {
            signal: controller.signal,
        }
    )
}

export interface IRequestGetConversationsFilters {
    entity_labels: string[]
    intent_names: string[]
    action_names: string[]
}

export const getConversationsFilters = (controller: AbortController) =>
    axiosAuth.get<IRequestGetConversationsFilters>(`/conversations/filters`, {
        signal: controller.signal,
    })

export const getConversation = (
    controller: AbortController,
    conversationId: string
) =>
    axiosAuth.get<MessageType[]>(`/conversations/${conversationId}`, {
        signal: controller.signal,
    })

export const deleteConversation = (conversationId: string) =>
    axiosAuth.delete(`/conversations/${conversationId}`)
